const listHasLink = () =>{
    if(document.querySelector('.ume-starter-list-has-link')){
        document.addEventListener('click', (ev)=>{
            if(!ev.target.classList.contains('ume-starter-list-has-link')) return;
            let link = ev.target.querySelector('a');
            if(link !== null){
                link.click();
            }

        })
    }
}
export default listHasLink;